import { useEffect, useState } from 'react';

import client from '../api/client';

// GET /api/shipping/methods -> [{ code, label, cost (cents), estimate }] (public).
export default function useShipping() {
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    client
      .get('/shipping/methods')
      .then(({ data }) => {
        if (active) setMethods(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (active) setMethods([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { methods, loading };
}
